










































































































































































































































































































































































































































































































































































































































































































import { Component, Mixins, Prop } from 'vue-property-decorator';
import MyForm from '@/mixins/form';
import _ from 'lodash';
import moment from 'moment';
import AreaPicker from '@/components/areapicker.vue';
import Amap from '@/components/amap.vue';

import MyConfig from '@/config';

import NoteAdd from './note_add.vue';

@Component({
  components: {
    AreaPicker,
    Amap,
    NoteAdd,
  },
})
export default class extends Mixins(MyForm) {
  @Prop() stadiumId!: number;

  noteAddModalVisible = false

  editData: any = {}

  apiserver: string = MyConfig.casapi;

  headers: any = {
    Authorization: window.localStorage.getItem('token'),
  };

  stadiumPhotoList: any[] = [];

  publicityList: any[] = [];

  amapcity: any = '';

  amapaddr = '';

  confirmDirty = true;

  form1: any;

  nearStadiums: any[] = [];

  previewVisible = false;

  previewImage = '';

  imageUrl = '';

  mountStatus = false;

  noteLoading = false;

  noteColumns: any[] = [
    { title: '编号', dataIndex: 'id' },
    { title: '时间', dataIndex: 'note_time' },
    { title: '洽谈对象', dataIndex: 'to' },
    { title: '洽谈方式', dataIndex: 'way' },
    { title: '洽谈内容摘要', scopedSlots: { customRender: 'note' } },
    { title: '图片', scopedSlots: { customRender: 'picurl' } },
  ];

  notes: any[] = [];

  showNoteAddModal() {
    this.noteAddModalVisible = true;
  }

  hideNoteAddModal() {
    this.noteAddModalVisible = false;
    this.loadNotes();
  }

  async loadNotes() {
    this.noteLoading = true;
    const res = await this.$store.dispatch('stadium/notes', {
      stadium_id: this.stadiumId,
    });
    if (res && res.Message && res.Message === 'success') {
      // console.log(res)
      this.notes = res.Data || [];
    }

    this.noteLoading = false;
  }

  normFile(e: any) {
    // console.log('Upload event:', e);
    if (Array.isArray(e)) {
      return e;
    }
    return e && e.fileList;
  }

  handleStadiumPhotoChange({ file, fileList }: any) {
    if (file.status == 'done' || file.status == 'removed') {
      // console.log(fileList)
      this.stadiumPhotoList = fileList;

      const fieldName = 'stadium_photo';
      // let fieldValue: any;

      const arr: string[] = [];
      for (const obj of fileList) {
        if (obj.status == 'done') {
          arr.push(obj.response.Data);
        }
      }
      const fieldValue: any = arr.join(',');

      this.$store.dispatch('stadium/researchReportChangeField', {
        stadium_id: this.stadiumId,
        field_name: fieldName,
        field_value: fieldValue,
      });
    }
  }

  handlePublicityChange({ file, fileList }: any) {
    if (file.status == 'done') {
      this.publicityList = fileList;

      const fieldName = 'publicity';
      // let fieldValue: any;

      const arr: string[] = [];
      for (const obj of fileList) {
        if (obj.status == 'done') {
          arr.push(obj.response.Data);
        }
      }
      const fieldValue: any = arr.join(',');

      this.$store.dispatch('stadium/researchReportChangeField', {
        stadium_id: this.stadiumId,
        field_name: fieldName,
        field_value: fieldValue,
      });
    }
  }

  hidePreview() {
    this.previewVisible = false;
  }

  showPreview(file: any) {
    this.previewImage = file.url || file.thumbUrl;
    this.previewVisible = true;
  }

  handleRemove() {
    return new Promise((resolve) => {
      this.$confirm({
        title: '确认信息',
        content: '你确定要删除吗？',
        onOk: async () => {
          resolve(true);
        },
        onCancel: () => {
          resolve(false);
        },
      });
    });
  }

  amapcallback(lng: any, lat: any) {
    this.form1.setFieldsValue({
      longitude: lng,
      latitude: lat,
    });
    this.handleSave(
      {},
      {
        longitude: lng,
      },
    );

    this.handleSave(
      {},
      {
        latitude: lat,
      },
    );

    this.loadNearStadium(`${lng},${lat}`);
  }

  beforeCreate() {
    this.form1 = this.$form.createForm(this, {
      onValuesChange: (props: any, values: any) => this.handleSave(props, values),
    });
  }

  handlePercentBlur(e: any) {
    //   this.form1.validateFields(['member_percent', 'block_percent', 'guest_percent', 'other_percent'], { force: true });
  }

  validatePercent(rule: any, value: any, callback: any) {
    const form: any = this.form1;

    const memberPercent = Number(form.getFieldValue('member_percent'));
    const blockPercent = Number(form.getFieldValue('block_percent'));
    const guestPercent = Number(form.getFieldValue('guest_percent'));
    const otherPercent = Number(form.getFieldValue('other_percent'));
    //   console.log(memberPercent + blockPercent + guestPercent + otherPercent)

    if (memberPercent + blockPercent + guestPercent + otherPercent > 100) {
      //   this.confirmDirty = true
      callback('占比合计不能超过100%');
    } else {
      //   this.confirmDirty = false
      callback();
    }
  }

  // 是保存
  handleSave(props: any, values: any) {
    if (this.mountStatus == true) return;

    this.$nextTick(() => {
      let fieldName = '';
      let fieldValue: any = '';

      // eslint-disable-next-line guard-for-in
      for (const k in values) {
        fieldName = k;
        fieldValue = values[k];
      }

      if (fieldName == 'stadium_photo') {
        return;
      } if (fieldName == 'publicity') {
        return;
      }

      const form: any = this.form1;

      const memberPercent = Number(
        form.getFieldValue('member_percent'),
      );
      const blockPercent = Number(form.getFieldValue('block_percent'));
      const guestPercent = Number(form.getFieldValue('guest_percent'));
      const otherPercent = Number(form.getFieldValue('other_percent'));

      //   console.log(memberPercent + blockPercent + guestPercent + otherPercent)

      if (memberPercent + blockPercent + guestPercent + otherPercent > 100) {
        return;
      }

      if (fieldName == 'start_time') {
        fieldValue = fieldValue.format('YYYY-MM-DD');
      } else if (fieldName == 'products') {
        fieldValue = fieldValue.join(',');
      } else if (fieldName == 'area') {
        fieldValue = fieldValue.join(',');
      }

      this.$store.dispatch('stadium/researchReportChangeField', {
        stadium_id: this.stadiumId,
        field_name: fieldName,
        field_value: fieldValue,
      });
    });
  }

  // 是提交
  handleSubmit() {
    this.form1.validateFieldsAndScroll((err: any, fieldValues: any) => {
      if (!err) {
        this.$confirm({
          title: '确认信息',
          content: '你确定要提交吗？提交后无法修改',
          onOk: async () => {
            const res = await this.$store.dispatch(
              'stadium/researchReportSave',
              {
                stadium_id: this.stadiumId,
                is_submit: 1,
                ...fieldValues,
              },
            );
            if (res && res.Message && res.Message === 'success') {
              this.$message.success('提交成功');
            } else {
              this.$message.error('提交失败');
            }
          },
        });
      }
    });
  }

  async loadNearStadium(location: string) {
    const res = await this.$store.dispatch('stadium/nearStadium', {
      location,
      radius: 10000,
    });

    if (res && res.Message && res.Message === 'success') {
      this.nearStadiums = res.Data.pois;

      for (const s of this.nearStadiums) {
        this.addMarker(s.name, s.location);
      }
    }
  }

  addMarker(title: string, location: string) {
    const arr = location.split(',');
    const map: any = this.$refs.amap1;
    map.addMarker({
      title, label: title, lng: arr[0], lat: arr[1],
    });
  }

  async mounted() {
    this.mountStatus = true;

    this.loadNotes();
    const res = await this.$store.dispatch('stadium/researchReportDetail', {
      stadium_id: this.stadiumId,
    });
    //   console.log(res)
    if (res && res.Data) {
      this.formData = res.Data;

      if (res.Data.stadium_photo) {
        //   console.log(res.Data.stadium_photo)
        // const photo: any[] = [];
        res.Data.stadium_photo
          .split(',')
          .forEach((element: any, index: number, array: any) => {
            // console.log('1')
            this.stadiumPhotoList.push({
              uid: `${Math.random()}`,
              name: `${Math.random()}`,
              status: 'done',
              url: this.renderImage(element),
              response: { Data: element },
            });
          });

        //   console.log(this.stadiumPhotoList)

        this.form1.setFieldsValue({
          stadium_photo: this.stadiumPhotoList,
        });
      }

      if (res.Data.publicity) {
        this.publicityList.push({
          uid: `${Math.random()}`,
          name: `${Math.random()}`,
          status: 'done',
          url: this.renderImage(res.Data.publicity),
          response: { Data: res.Data.publicity },
        });

        //   console.log(this.publicityList)

        this.form1.setFieldsValue({
          publicity: this.publicityList,
        });
      }

      if (res.Data.longitude && res.Data.latitude) {
        this.loadNearStadium(`${res.Data.longitude},${res.Data.latitude}`);
      } else {
        if (res.Data.s_longitude && res.Data.s_latitude) {
          this.loadNearStadium(
            `${res.Data.s_longitude},${res.Data.s_latitude}`,
          );
        }
      }
    }

    this.mountStatus = false;
  }
}
